import { render, staticRenderFns } from "./AllocateCondition.vue?vue&type=template&id=0bf947b9&scoped=true&"
import script from "./AllocateCondition.vue?vue&type=script&lang=js&"
export * from "./AllocateCondition.vue?vue&type=script&lang=js&"
import style0 from "./AllocateCondition.vue?vue&type=style&index=0&id=0bf947b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf947b9",
  null
  
)

export default component.exports